import { createButton } from '@vfde-brix/ws10/button';
import { createNotification, INotificationProperties, Notification } from '@vfde-brix/ws10/notification';
import { debugInfo } from '../utils/debug';
import { mountComponent } from '../utils/mount';
import { AppId } from '../enums/elementId';

const mountNotificationBtn = (props: INotificationProperties, containerEl?: Element | null) => {
    if (!containerEl || !props.containerButtons) {
        debugInfo('Did not mount any notification btn.');
        return;
    }

    const { containerButtons } = props;

    // workaround to apply onClick on button inside notification
    for (const [index, button] of containerButtons.entries()) {
        if (button?.business) {
            createButton(containerEl.getElementsByTagName('span')[index], {
                ...props.containerButtons[index].business,
            });
        }
    }
};

export const mountResultNotification = (props?: INotificationProperties): Notification | undefined => {
    const notificationProps = props || {
        optState: 'success',
        optBackground: 'white',
        stdHeadline: 'Placeholder',
        txtContent: 'Placeholder',
        business: {},
    };
    const notificationComponent = mountComponent(
        AppId.ID_WRAPPER_NOTIFICATION_RESULT,
        createNotification,
        notificationProps,
    );

    mountNotificationBtn(
        notificationProps,
        notificationComponent?.getContainerElement()
    );

    return notificationComponent;
};
